import { FeatureFlag } from "@common-shared/config/featureFlags.config"

export const FEATURE_FLAGS_CONFIG = {
    pollingInterval: 5 * 60 * 1000, // 5 minutes in milliseconds

    get bulkCheckerFeatureFlags(): FeatureFlag[] {
        return [
            FeatureFlag.ONE_VERIFY_STANDARD_BULK_CHECKS,
            FeatureFlag.ONE_VERIFY_DISCOVER_BULK_CHECKS,
            FeatureFlag.ONE_VERIFY_SCAN_BULK_CHECKS,
            FeatureFlag.ONE_VERIFY_MEDICAID_BULK_CHECKS,
        ]
    },

    get manualCheckerFeatureFlags(): FeatureFlag[] {
        return [
            FeatureFlag.ONE_VERIFY_STANDARD_MANUAL_CHECK,
            FeatureFlag.ONE_VERIFY_DISCOVER_MANUAL_CHECK,
            FeatureFlag.ONE_VERIFY_SCAN_MANUAL_CHECK,
            FeatureFlag.ONE_VERIFY_MEDICAID_MANUAL_CHECK,
        ]
    },

    get checkerFeatureFlags(): FeatureFlag[] {
        return [
            ...FEATURE_FLAGS_CONFIG.bulkCheckerFeatureFlags,
            ...FEATURE_FLAGS_CONFIG.manualCheckerFeatureFlags,
        ]
    },
}
